import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dcfa9c86"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "table-container"
}
const _hoisted_2 = { class: "table table-row-dashed table-hover table-layout-fixed" }
const _hoisted_3 = { style: {"background-color":"aliceblue","position":"sticky","top":"0"} }
const _hoisted_4 = { class: "text-muted fw-bold text-uppercase" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-success fw-bold text-uppercase" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "me-1" }

import { ref } from "vue";
import AccountService from "../../services/AccountService";
import { Memo } from "@element-plus/icons-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewRebateStat',
  props: {
    item: {},
    from: {},
    to: {}
  },
  setup(__props: any) {

const props = __props;



const isLoading = ref(false);
const isShow = ref(false);
const data = ref(<any>[]);
const totalData = ref(<any>[]);

const fecthData = async () => {
  isLoading.value = true;
  try {
    data.value = await AccountService.getChildRebateStat({
      uid: props.item.uid,
      from: props.from,
      to: props.to,
    });
    var currency = data.value[Object.keys(data.value)[0]].amounts;
    currency = Object.keys(currency)[0];
    const total = {
      volume: Object.values(data.value).reduce(
        (acc: number, cur: any) => acc + cur.volume,
        0
      ),
      amounts: Object.values(data.value).reduce(
        (acc: any, cur: any) => acc + cur.amounts[currency],
        0
      ),
      currency: currency,
    };
    totalData.value = total;
  } catch (e) {
    console.log(e);
  }
  isLoading.value = false;
};

const onShow = () => {
  isShow.value = true;
  fecthData();
};

return (_ctx: any,_cache: any) => {
  const _component_BalanceShow = _resolveComponent("BalanceShow")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    trigger: "click",
    placement: "left",
    width: 800,
    onShow: onShow
  }, {
    default: _withCtx(() => [
      (isShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("table", _hoisted_2, [
              _createElementVNode("thead", _hoisted_3, [
                _createElementVNode("tr", _hoisted_4, [
                  _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t("fields.name")), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.currency")), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.volume")), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.amount")), 1)
                ]),
                _createElementVNode("tr", _hoisted_6, [
                  _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("title.total")), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t(`type.currency.${totalData.value.currency}`)), 1),
                  _createElementVNode("th", null, _toDisplayString(totalData.value.volume), 1),
                  _createElementVNode("th", null, [
                    _createVNode(_component_BalanceShow, {
                      "currency-id": Number(totalData.value.currency),
                      balance: totalData.value.amounts,
                      class: _normalizeClass(totalData.value.amounts > 0 ? '' : 'text-danger')
                    }, null, 8, ["currency-id", "balance", "class"])
                  ])
                ])
              ]),
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                    _createVNode(_component_LoadingRing)
                  ]))
                : (!isLoading.value && data.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                      _createVNode(_component_NoDataBox)
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, key) => {
                        return (_openBlock(), _createElementBlock("tr", { key: key }, [
                          _createElementVNode("td", _hoisted_11, _toDisplayString(key), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.amounts, (amountValue, amountKey) => {
                            return (_openBlock(), _createElementBlock("td", { key: amountKey }, [
                              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t(`type.currency.${amountKey}`)), 1)
                            ]))
                          }), 128)),
                          _createElementVNode("td", null, _toDisplayString(item.volume), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.amounts, (amountValue, amountKey) => {
                            return (_openBlock(), _createElementBlock("td", { key: amountKey }, [
                              _createVNode(_component_BalanceShow, {
                                "currency-id": Number(amountKey),
                                balance: amountValue,
                                class: _normalizeClass(amountValue > 0 ? '' : 'text-danger')
                              }, null, 8, ["currency-id", "balance", "class"])
                            ]))
                          }), 128))
                        ]))
                      }), 128))
                    ]))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    reference: _withCtx(() => [
      _createVNode(_component_el_button, {
        icon: _unref(Memo),
        size: "small",
        circle: ""
      }, null, 8, ["icon"])
    ]),
    _: 1
  }))
}
}

})